/**
 * Where a search result points.
 *
 * The rule was written out three times inside Home.js — the suggestion
 * dropdown, the keyboard handler and the result list — which is how a game
 * ended up addressed as a movie in one of them. It is one function now, and
 * the only one with a test.
 *
 * `id` on a search result is the TMDb id: that is what the search response has
 * always carried. A game has none and never will, so it is addressed by
 * `project_id`, our own id, and is the one case that has to be checked first.
 */
export function searchResultHref(r) {
  if (!r) return '/';
  if (r.category === 'Game' || r.media_type === 'game') {
    return `/game/${r.project_id}`;
  }
  // In-development titles live in the graph, not in TMDb.
  if (r.is_insider) return `/insider/project/${r.id}`;
  if (r.category === 'Person') return `/person/${r.id}`;
  return `/${r.category === 'TV Series' ? 'tv' : 'movie'}/${r.id}`;
}
